"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CameraIcon = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var themes_1 = require("../../themes");
var SVGBox_1 = require("./SVGBox");
var RegularSizedIcon = function (_a) {
    var _b = _a.fill, fill = _b === void 0 ? 'transparent' : _b, _c = _a.size, size = _c === void 0 ? 24 : _c, rest = __rest(_a, ["fill", "size"]);
    return (jsx_runtime_1.jsxs(SVGBox_1.SVGBox, __assign({ size: size, viewBox: "0 0 26 24" }, rest, { children: [jsx_runtime_1.jsx("path", { d: "M16.5 4C16.1936 3.38713 15.5672 3 14.882 3H11.118C10.4328 3 9.80643 3.38713 9.5 4V4C9.19357 4.61287 8.56717 5 7.88197 5H3C1.89543 5 1 5.89543 1 7V19C1 20.1046 1.89543 21 3 21H23C24.1046 21 25 20.1046 25 19V7C25 5.89543 24.1046 5 23 5H18.118C17.4328 5 16.8064 4.61287 16.5 4V4Z", stroke: "black", strokeWidth: "1", fill: fill }, void 0),
            jsx_runtime_1.jsx("circle", { cx: "13", cy: "13", r: "5", stroke: "black", strokeWidth: "1", fill: fill ? themes_1.THEME.colors.basic.White100 : 'transparent' }, void 0)] }), void 0));
};
var BigSizedIcon = function (_a) {
    var _b = _a.fill, fill = _b === void 0 ? 'transparent' : _b, _c = _a.size, size = _c === void 0 ? 32 : _c, rest = __rest(_a, ["fill", "size"]);
    return (jsx_runtime_1.jsxs(SVGBox_1.SVGBox, __assign({ size: size, viewBox: "0 0 34 32" }, rest, { children: [jsx_runtime_1.jsx("path", { d: "M21.6667 5.33333C21.2581 4.51618 20.4229 4 19.5093 4H14.4907C13.5771 4 12.7419 4.51618 12.3333 5.33333V5.33333C11.9248 6.15049 11.0896 6.66667 10.176 6.66667H3.66667C2.19391 6.66667 1 7.86057 1 9.33333V25.3333C1 26.8061 2.19391 28 3.66667 28H30.3333C31.8061 28 33 26.8061 33 25.3333V9.33333C33 7.86057 31.8061 6.66667 30.3333 6.66667H23.824C22.9104 6.66667 22.0752 6.15049 21.6667 5.33333V5.33333Z", stroke: "black", strokeWidth: "1.5", fill: fill }, void 0),
            jsx_runtime_1.jsx("circle", { cx: "17", cy: "17.3333", r: "6.66667", stroke: "black", strokeWidth: "1.5", fill: fill ? themes_1.THEME.colors.basic.White100 : 'transparent' }, void 0)] }), void 0));
};
var CameraIcon = function (props) {
    var _a = props.size, size = _a === void 0 ? 24 : _a, rest = __rest(props, ["size"]);
    return size < 32 ? (jsx_runtime_1.jsx(RegularSizedIcon, __assign({ size: size }, rest), void 0)) : (jsx_runtime_1.jsx(BigSizedIcon, __assign({ size: size }, rest), void 0));
};
exports.CameraIcon = CameraIcon;
//# sourceMappingURL=CameraIcon.js.map